import { render, staticRenderFns } from "./AdditionalParams.vue?vue&type=template&id=052c2b97"
import script from "./AdditionalParams.vue?vue&type=script&lang=js"
export * from "./AdditionalParams.vue?vue&type=script&lang=js"
import style0 from "./AdditionalParams.vue?vue&type=style&index=0&id=052c2b97&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports